/**
 *
 * @module entry
 * @desc {SDK.Account} entry point.
 *
 */

import AccountApi from './accountApi';
import AccountManager from './accountManager';
import Gender from './gender';

/**
 *
 * @typedef SDK.Account
 * @type {Object}
 *
 * @property {AccountApi} AccountApi
 * @property {AccountManager} AccountManager
 * @property {Gender} Gender
 *
 */

/**
 *
 * @type {SDK.Account}
 *
 */
export default {

    AccountApi,
    AccountManager,
    Gender

};



// WEBPACK FOOTER //
// ./src/account/entry.js